<template>
  <div id="extra-component-form-validation-demo">

    <!--<p class="mb-4"> <a href="#" rel="nofollow">Alert</a> Page to config the Alert that used in the system</p>-->
    <!---->
    <List></List>
  </div>
</template>

<script>

import List from "./UserstList.vue"

export default {
  components: {
    List
  }
}
</script>
